var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-weather"},[_c('div',{staticClass:"content-gis-map"},[_c('div',{style:(_vm.minHeight),attrs:{"id":(_vm.nameMap + "_" + _vm.initialDate)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }